import React from "react";
interface QuantityCountBadgeProps {
  unitDisplayText: string;
  quantity: number;
  isGridView: boolean;
}
const QuantityCountBadge = ({
  unitDisplayText,
  quantity,
  isGridView
}: QuantityCountBadgeProps) => {
  const containerStyles = isGridView ? "bottom-[4px] left-[4px]" : "bottom-[14px] left-[14px]";
  // add commas to numbers with > 4 digits only
  const formattedQuantity = quantity > 9999 ? new Intl.NumberFormat().format(quantity) : quantity;
  return <span className={`flex flex-col items-center font-bold text-xs absolute uppercase rounded-sm-1/2 z-20 px-1/2 bg-[rgba(255,255,255,0.8)] ${containerStyles}`} data-testid="plp-quantity-flag" style={{
    boxShadow: "0 1px 3px rgba(0,0,0,.12)",
    WebkitFontSmoothing: "antialiased"
  }} data-sentry-component="QuantityCountBadge" data-sentry-source-file="index.tsx">
      <span className="w-full py-1 px-1/2 bg-gray-50 text-gray-800 text-center rounded-t-sm-1/2 leading-[10px]">
        {formattedQuantity}
      </span>
      <span className="w-full py-1 px-1/2 bg-[rgba(35,42,30,0.6)] text-white text-center text-2xs rounded-b-sm-1/2 leading-[10px]">
        {unitDisplayText}
      </span>
    </span>;
};
export default QuantityCountBadge;